import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card"
}
const _hoisted_2 = { class: "block lot" }
const _hoisted_3 = {
  key: 0,
  class: "row"
}
const _hoisted_4 = { class: "row-value" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "row-value" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "row-value" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "row-value" }
const _hoisted_11 = { class: "block eoi" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "row-value" }
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = { class: "row-value" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "row-value" }
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "row-value" }
const _hoisted_20 = {
  key: 0,
  class: "block-title"
}
const _hoisted_21 = {
  key: 1,
  class: "block eoi"
}
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "row-value" }
const _hoisted_24 = { class: "row" }
const _hoisted_25 = { class: "row-value" }
const _hoisted_26 = { class: "row" }
const _hoisted_27 = { class: "row-value" }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "row-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($props.lot)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ($props.lot.eoiId?.contractConditions?.subjectToFinance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _cache[0] || (_cache[0] = _createElementVNode("div", { class: "row-title" }, "Finance due date:", -1)),
                _createElementVNode("div", _hoisted_4, _toDisplayString($props.lot.financeDueDate ? $setup.formatDate($props.lot.financeDueDate) : "-"), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "row-title" }, "Settlement date:", -1)),
            _createElementVNode("div", _hoisted_6, _toDisplayString($props.lot.settlementDate ? $setup.formatDate($props.lot.settlementDate) : "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "row-title" }, "Buyer Type:", -1)),
            _createElementVNode("div", _hoisted_8, _toDisplayString($props.lot?.eoiId?.buyerType || "-"), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[3] || (_cache[3] = _createElementVNode("div", { class: "row-title" }, "Agent Referrer:", -1)),
            _createElementVNode("div", _hoisted_10, _toDisplayString($props.lot?.eoiId?.agentReferrer || "-"), 1)
          ])
        ]),
        _cache[12] || (_cache[12] = _createElementVNode("h3", { class: "block-title" }, "Contract Conditions:", -1)),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "row-title" }, "Contract subject to finance?", -1)),
            _createElementVNode("div", _hoisted_13, _toDisplayString($setup.getContractConditionsFields("subjectToFinance")), 1)
          ]),
          ($props.lot.eoiId?.contractConditions?.subjectToFinance)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[5] || (_cache[5] = _createElementVNode("div", { class: "row-title" }, "Finance status:", -1)),
                _createElementVNode("div", _hoisted_15, _toDisplayString($props.lot.eoiId ? $props.lot.eoiId.contractConditions.financeStatus : "-"), 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_16, [
            _cache[6] || (_cache[6] = _createElementVNode("div", { class: "row-title" }, "Contract subject to FIRB?", -1)),
            _createElementVNode("div", _hoisted_17, _toDisplayString($setup.getContractConditionsFields("FIRB")), 1)
          ]),
          _createElementVNode("div", _hoisted_18, [
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "row-title" }, "Contract subject to any other conditions?", -1)),
            _createElementVNode("div", _hoisted_19, _toDisplayString($props.lot?.eoiId?.contractConditions?.otherConditions? $props.lot?.eoiId?.contractConditions?.otherConditions
: $setup.getContractConditionsFields("otherConditions")), 1)
          ])
        ]),
        ($setup.checkFinanceBrokerDetails)
          ? (_openBlock(), _createElementBlock("h3", _hoisted_20, "Finance broker details"))
          : _createCommentVNode("", true),
        ($setup.checkFinanceBrokerDetails)
          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "row-title" }, "Lending institution:", -1)),
                _createElementVNode("div", _hoisted_23, _toDisplayString($props.lot.eoiId?.contractConditions?.financeBrokerDetails?.lendingInstitution || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "row-title" }, "Finance broker:", -1)),
                _createElementVNode("div", _hoisted_25, _toDisplayString($props.lot.eoiId?.contractConditions?.financeBrokerDetails?.brokerName || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_26, [
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "row-title" }, "Email:", -1)),
                _createElementVNode("div", _hoisted_27, _toDisplayString($props.lot.eoiId?.contractConditions?.financeBrokerDetails?.email || "-"), 1)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "row-title" }, "Phone:", -1)),
                _createElementVNode("div", _hoisted_29, _toDisplayString($props.lot.eoiId?.contractConditions?.financeBrokerDetails?.phone || "-"), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}